import React from 'react';
import { useEffect, useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { formChangedAction } from '../../actions/index';
import EnlargableTextbox from 'components/common/EnlargableTextbox';
import { schedulersDataDetailAction } from 'actions/SystemSettings/systemSettingsAction';

export const SystemSettingDetails = () => {
  const dispatch = useDispatch();

  const resetBackgroundJobData = () => {
    dispatch(
      schedulersDataDetailAction({
        'jobName': '',
        'encryptedResponseJobId': '',
        'jobType': '',
        'triggerTime': '',
        'monthDate': null,
        'weekDay': '',
        'status': 'Active'
      })
    );
  };

    const systemSettingReducer = useSelector(
    state => state.rootReducer.systemSettingReducer
  );
  var schedulerData = systemSettingReducer.schedulerData;

  if (
    !systemSettingReducer.schedulerData ||
    Object.keys(systemSettingReducer.schedulerData).length <= 0
  ) {
    resetBackgroundJobData();
  }

    const systemSettingErrorReducer = useSelector(
    state => state.rootReducer.systemSettingErrorReducer
  );
  const schedulerErr = systemSettingErrorReducer.schedulersDetailsError;

  const formChangedReducer = useSelector(
    state => state.rootReducer.formChangedReducer
  );
  var formChangedData = formChangedReducer.formChanged;
  const [formHasError, setFormError] = useState(false);

  let token = localStorage.getItem('Token') || sessionStorage.getItem('Token');
  const headers = {
    Authorization: `Bearer ${JSON.parse(token).value}`
  };

  useEffect(() => {
    if (!schedulerData.weekDay && schedulerData.jobType == 'Weekly') {
      $('#txtWeekDay').attr('disabled', true);
    }
    if (!schedulerData.monthDate && schedulerData.jobType == 'Monthly') {
      $('#txtMonthDate').attr('disabled', true);
    }
  }, [])

  const handleFieldChange = e => {
    if (e.target.name == 'jobType' && e.target.value == "Weekly") {
      dispatch(
        schedulersDataDetailAction({
          ...schedulerData,
        [e.target.name]: e.target.value,
          monthDate: null,
        })
      );
      $('#txtWeekDay').attr('disabled', false);
    } else if (e.target.name == 'jobType' && e.target.value == "Monthly") {
      dispatch(
        schedulersDataDetailAction({
          ...schedulerData,
          [e.target.name]: e.target.value,
          weekDay: ""
        })
      );
      $('#txtWeekDay').attr('disabled', true);
      $('#txtMonthDate').attr('disabled', false);
    } else if (e.target.name == 'jobType' && e.target.value == "Daily") {
      dispatch(
        schedulersDataDetailAction({
          ...schedulerData,
          [e.target.name]: e.target.value,
          monthDate: null,
          weekDay: ""
        })
      );
      $('#txtWeekDay').attr('disabled', true);
      $('#txtMonthDate').attr('disabled', true);
    } else {
      dispatch(
        schedulersDataDetailAction({
          ...schedulerData,
          [e.target.name]: e.target.value
        })
      );
    }

    if (schedulerData.encryptedJobId) {
      dispatch(
        formChangedAction({
          ...formChangedData,
          jobUpdate: true
        })
      );
    } else {
      dispatch(
        formChangedAction({
          ...formChangedData,
          jobAdd: true
        })
      );
    }
  };

  return (
    <>

      {schedulerData && (
        <>
          <Form
            noValidate
            validated={formHasError}
            className="details-form job-module-card"
            id="addSchedulerDetail"
          >
            <Row>
              <Col className="me-3 ms-3">
                <Row className="mb-3">
                  <Form.Label>
                    Background Job<span className="text-danger">*</span>
                  </Form.Label>
                  <EnlargableTextbox
                    id="txtJobName"
                    name="jobName"
                    maxLength={50}
                    value={schedulerData.jobName}
                    onChange={handleFieldChange}
                    placeholder="Background Job"
                    required={true}
                  />
                  {Object.keys(schedulerErr.jobNameErr).map(key => {
                    return (
                      <span className="error-message">
                        {schedulerErr.jobNameErr[key]}
                      </span>
                    );
                  })}
                </Row>
                <Row className="mb-3">
                  <Form.Label>
                    Week Day
                  </Form.Label>
                  <Form.Select
                    id="txtWeekDay"
                    name="weekDay"
                    disabled={!(schedulerData.weekDay || schedulerData.jobType === 'Weekly')}
                    value={schedulerData.weekDay}
                    onChange={handleFieldChange}
                    required
                  >
                    <option value="">Select Day</option>
                    <option value="Sunday">Sunday</option>
                    <option value="Monday">Monday</option>
                    <option value="Tuesday">Tuesday</option>
                    <option value="Wednesday">Wednesday</option>
                    <option value="Thursday">Thursday</option>
                    <option value="Friday">Friday</option>
                    <option value="Saturday">Saturday</option>

                  </Form.Select>
                  {Object.keys(schedulerErr.weekDayErr).map(key => {
                    return (
                      <span className="error-message">
                        {schedulerErr.weekDayErr[key]}
                      </span>
                    );
                  })}
                </Row>
              </Col>
              <Col className="me-3 ms-3">
                <Row className="mb-3">
                  <Form.Label>
                    Type<span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Select
                    id="txtType"
                    name="jobType"
                    value={schedulerData.jobType}
                    onChange={handleFieldChange}
                    required
                  >
                    <option value="">Select Type</option>
                    <option value="Daily">Daily</option>
                    <option value="Weekly">Weekly</option>
                    <option value="Monthly">Monthly</option>
                  </Form.Select>
                  {Object.keys(schedulerErr.jobTypeErr).map(key => {
                    return (
                      <span className="error-message">
                        {schedulerErr.jobTypeErr[key]}
                      </span>
                    );
                  })}
                </Row>
                <Row className="mb-3">
                  <Form.Label>
                    Month Date
                  </Form.Label>
                  <Form.Control
                    id="txtMonthDate"
                    name="monthDate"
                    type="date"
                      disabled={!(schedulerData.monthDate || schedulerData.jobType === 'Monthly')}
                    value={schedulerData?.monthDate}
                    onChange={handleFieldChange}
                  />
                  {Object.keys(schedulerErr.monthDateErr).map(key => {
                    return (
                      <span className="error-message">
                        {schedulerErr.monthDateErr[key]}
                      </span>
                    );
                  })}
                </Row>
              </Col>
              <Col className="me-3 ms-3">
                <Row className="mb-3">
                  <Form.Label>Trigger Time<span className="text-danger">*</span></Form.Label>
                  <Form.Control
                    id="txtTriggerTime"
                    name="triggerTime"
                    type="time"
                    maxLength={26}
                    value={schedulerData.triggerTime}
                    onChange={handleFieldChange}
                    placeholder="Trigger Time"
                  />
                  {Object.keys(schedulerErr.triggerTimeErr).map(key => {
                    return (
                      <span className="error-message">
                        {schedulerErr.triggerTimeErr[key]}
                      </span>
                    );
                  })}
                </Row>
                {/* <Row className="mb-3">
                  <Form.Label>Active Status</Form.Label>
                  <Form.Select
                    id="txtStatus"
                    name="status"
                    value={schedulerData.status}
                    onChange={handleFieldChange}
                  >
                    <option value="Active">Active</option>
                    <option value="InActive">InActive</option>
                  </Form.Select>
                </Row> */}
              </Col>
            </Row>
          </Form>
        </>
      )}
    </>
  );
};

export default SystemSettingDetails;
